import { Flex, Text, Heading } from "@chakra-ui/react"
import ReactPlayer from "react-player"
import Benefit from "./Benefit"

const FlexInfo = () => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      paddingTop="24px"
      paddingBottom="24px"
      width={["80vw", "80vw", "60vw", "60vw"]}
    >
      <Heading
        marginTop="16px"
        marginBottom="16px"
        textAlign={["center", "center", "left", "left"]}
      >
        Energia de care ai nevoie
      </Heading>
      <Text textAlign="center">
        <strong>CEZ Confort Asigurat</strong>, produsul nostru prin care iti
        furnizam energia electrica de care ai nevoie si protectie prin asigurari
        specializate!
      </Text>
      <Text marginTop="16px" textAlign="center">
        Suntem atenti la nevoile tale si ne adaptam acestora: alege{" "}
        <strong>CEZ Confort Asigurat</strong> sau{" "}
        <strong>CEZ Confort Asigurat Plus</strong> si lasa grijile in seama
        noastra.
      </Text>
      <Flex
        marginTop="16px"
        justifyContent="center"
        alignItems="center"
        width="100%"
        padding="16px"
      >
        <ReactPlayer
          url="https://www.youtube.com/watch?v=xBPWMSJDiMQ"
          controls={true}
          muted={true}
          loop={true}
          playing={true}
        />
      </Flex>
      <Text
        marginTop="16px"
        fontSize="lg"
        textAlign={["center", "center", "left", "left"]}
      >
        Ai toate beneficiile de mai jos intr-un singur tarif
      </Text>
      <Flex flexDirection={["column", "column", "row", "row"]}>
        <Benefit
          image="/cez-confort-asigurat/assets/energie-electrica.png"
          title="Energie electrica"
          text="Energie electrica la pret avantajos"
        />
        <Benefit
          image="/cez-confort-asigurat/assets/asigurare-viata.png"
          title="Asigurare de viata si somaj"
          text="Esti asigurat in caz de imbolnavire cu virusul Sars-CoV-2 sau pierderea locului de munca"
        />
        <Benefit
          image="/cez-confort-asigurat/assets/dispozitive-electrice.png"
          title="Asigurare de protectie impotriva daunelor electrice"
          text="Dispozitivele tale electrocasnice vor fi asigurate in caz de avarii provocate de fenomene electrice"
        />
      </Flex>
      <Flex flexDirection={["column", "column", "row", "row"]}>
        <Benefit
          image="/cez-confort-asigurat/assets/asistenta-de-urgenta-pentru-casa.png"
          title="Asistenta de urgenta pentru casa"
          text="Interventii de urgenta din partea unui expert in maxim 4 ore"
        />
        <Benefit
          image="/cez-confort-asigurat/assets/smartphone.png"
          title="Cont dedicat My CEZ"
          text="Iti poti crea un cont dedicat My CEZ pentru a avea la indemana toate detaliile contului tau"
        />
        <Benefit
          image="/cez-confort-asigurat/assets/factura-electronica.png"
          title="Factura electronica"
          text="Poti alege sa primesti factura pe e-mail la data emiterii"
        />
      </Flex>
    </Flex>
  )
}

export default FlexInfo
